import React, { useState } from "react";
import DaysMonitored from "./DaysMonitored";

const MetricSummary = ({ metrics }) => {
  const latest = metrics.at(-1)?.value || "--";
  const average =
    Math.round(metrics.reduce((acc, cur) => acc + cur.value, 0) / metrics.length) || "--";

  const [daysMonitored, setDaysMonitored] = useState(77); // Replace with actual data

  const handleEnableMonitoring = () => {
    // Replace with actual enable logic
    setDaysMonitored(1);
  };

  return (
    <div className="stats-summary-container">
      <div className="metrics-card">
        {/* 👤 Patient / Monitoring */}
        <DaysMonitored />


        {/* 🔢 Latest Metric */}
        <div className="metric-box">
          <div className="metric-label">LATEST</div>
          <div className="metric-value">{latest}</div>
          <div className="metric-date">now</div>
        </div>

        {/* 📊 Average */}
        <div className="metric-box">
          <div className="metric-label">AVERAGE</div>
          <div className="metric-value">{average}</div>
          <div className="metric-date">Last 24h</div>
        </div>
      </div>

      {/* 📝 Summary */}
      <div className="summary-card">
        <h3>Summary</h3>
        <p>
          Since updating the dosage of <strong>Hydrochlorothiazide</strong> from 2 to 3 mg,
          the patient’s anxiety attacks decreased by 15%, resting heart rate down to 70 bpm,
          but side effects like <strong>loss of taste</strong> have been introduced.
        </p>
      </div>

      <style>{`
        .stats-summary-container {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 24px;
        }

        .metrics-card {
          display: flex;
          justify-content: space-between;
          background: white;
          padding: 20px 32px;
          border-radius: 12px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        }

        .metric-box {
          text-align: center;
          flex: 1;
        }

        .metric-label {
          font-size: 12px;
          font-weight: 600;
          color: #6b7280;
          letter-spacing: 0.5px;
          margin-bottom: 4px;
        }

        .metric-value {
          font-size: 28px;
          font-weight: 700;
          color: #111827;
        }

        .metric-date {
          font-size: 12px;
          color: #9ca3af;
          margin-top: 4px;
        }

        .enable-btn {
          font-size: 11px;
          color: #4f46e5;
          background: transparent;
          border: none;
          margin-left: 8px;
          padding: 0;
          cursor: pointer;
          text-decoration: underline;
        }

        .enable-btn:hover {
          color: #4338ca;
        }

        .summary-card {
          background: white;
          padding: 20px 24px;
          border-radius: 12px;
          font-size: 14px;
          line-height: 1.6;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        }

        .summary-card h3 {
          margin-top: 0;
          margin-bottom: 12px;
          font-size: 16px;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default MetricSummary;
